import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/getting-started/page.tsx");
